module.exports = __webpack_public_path__ + "static/media/sing-up-background.990d9793.jpeg";